export const CATEGORY_GROUP: Record<string, string> = {
  GOAL_BUSINESS_PLAN: 'เป้าหมายและแผนการขยายธุรกิจ',
  GOAL_COST_PLAN: 'เป้าหมายและแผนการจัดการต้นทุน',
  GOAL_INVESTMENT_PLAN: 'เป้าหมายและแผนการลงทุน',
  GOAL_DEBT_PLAN: 'เป้าหมายและแผนการจัดการหนี้',
};

export enum OTHER_TARGETS_ID {
  GOAL_BUSINESS_PLAN = 1090,
  GOAL_COST_PLAN = 1094,
  GOAL_INVESTMENT_PLAN = 1097,
  GOAL_DEBT_PLAN = 1100,
}

export enum INFO_CATEGORY_TARGET_RELATED {
  GOAL_BUSINESS_PLAN = 'GOAL_BUSINESS_PLAN',
  GOAL_COST_PLAN = 'GOAL_COST_PLAN',
  GOAL_INVESTMENT_PLAN = 'GOAL_INVESTMENT_PLAN',
  GOAL_DEBT_PLAN = 'GOAL_DEBT_PLAN',
}

export const CATEGORY_TITLES: Record<
  string,
  { titleTh: string; titleEn: string }
> = {
  GOAL_BUSINESS_PLAN: {
    titleTh: 'เป้าหมายและแผนการขยายธุรกิจ',
    titleEn: 'Business expansion goals and plans',
  },
  GOAL_COST_PLAN: {
    titleTh: 'เป้าหมายและแผนการจัดการต้นทุน',
    titleEn: 'Cost management goals and plans',
  },
  GOAL_INVESTMENT_PLAN: {
    titleTh: 'เป้าหมายและแผนการลงทุน',
    titleEn: 'Investment goals and plans',
  },
  GOAL_DEBT_PLAN: {
    titleTh: 'เป้าหมายและแผนการจัดการหนี้',
    titleEn: 'Debt management goals and plans',
  },
};
